const buildType = require("./models");

module.exports = buildType({
  initializer: (model, document) => {
    model.name = document?.name;
  },
  code: "incomeCategories",
});
